import { FC, ReactElement } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { SingleGameSkeleton } from './SingleGame/Skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';

const GameSingleItemSkeletonDesktop = ({
  expanded,
  itemsCount = 2
}: {
  expanded?: boolean;
  itemsCount?: number;
}): ReactElement => {
  return (
    <div className="GameSingleItemSkeleton--desktop">
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px 8px'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <Skeleton.Avatar size={EIconSize._20} active />
          <Skeleton
            title={{
              style: {
                width: 150,
                margin: SpringConfigs.IS_RTL ? '0 8px 0 0' : '0 0 0 8px',
                height: 12
              }
            }}
            paragraph={false}
            active
          />
        </div>
      </div>
      {expanded
        ? new Array(itemsCount)
            .fill('')
            .map((_, i) => <GameSingleItemDetailsSkeletonDesktop key={i} />)
        : null}
    </div>
  );
};

export const GameSingleItemDetailsSkeletonDesktop = ({
  isSingleGameOpened = false
}: {
  isSingleGameOpened?: boolean;
}): ReactElement => {
  return (
    <>
      <div
        className="GameSingleItemDetailsSkeleton--desktop"
        style={isSingleGameOpened ? { marginBottom: '3px' } : {}}
      >
        <Skeleton
          title={{
            style: {
              width: 100,
              margin: SpringConfigs.IS_RTL ? '0 0 0 8px' : '0 8px 0 0',
              height: 8
            }
          }}
          paragraph={false}
          active
        />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Skeleton
            title={{
              style: {
                width: 100,
                margin: SpringConfigs.IS_RTL ? '0 0 0 8px' : '0 8px 0 0',
                height: 8
              }
            }}
            paragraph={false}
            active
          />
          {SpringConfigs.TEAM_LOGOS && (
            <Skeleton.Avatar
              size={EIconSize._18}
              active
              style={{ marginTop: '2px' }}
            />
          )}
          <Skeleton
            title={{
              style: {
                width: 8,
                margin: '0 8px',
                height: 16,
                display: 'flex',
                float: 'right'
              }
            }}
            paragraph={false}
            active
          />
          <Skeleton
            title={{
              style: {
                width: 8,
                margin: SpringConfigs.IS_RTL ? '0 0 0 8px' : '0 8px 0 0',
                height: 16,
                display: 'flex',
                float: 'right'
              }
            }}
            paragraph={false}
            active
          />
          {SpringConfigs.TEAM_LOGOS && (
            <Skeleton.Avatar
              size={EIconSize._18}
              active
              style={{ marginTop: '2px' }}
            />
          )}
          <Skeleton
            title={{
              style: {
                width: 100,
                margin: SpringConfigs.IS_RTL ? '0 8px 0 0' : '0 0 0 8px',
                height: 8
              }
            }}
            paragraph={false}
            active
          />
        </div>
        <Skeleton
          title={{
            style: {
              width: 50,
              margin: '0 0 0 8px',
              height: 8,
              float: SpringConfigs.IS_RTL ? 'left' : 'right'
            }
          }}
          paragraph={false}
          active
        />
      </div>
      {isSingleGameOpened ? <SingleGameSkeleton /> : null}
    </>
  );
};

export const GamesSkeletonDesktop = (): ReactElement => {
  return (
    <div>
      {Array.from({ length: 8 }, (v, i) => i).map(key => (
        <GameSingleItemSkeletonDesktop key={key} expanded />
      ))}
    </div>
  );
};

export const OpenedGameSkeletonDesktop: FC = () => {
  return (
    <div className="singleGameResultSkeleton">
      <GameSingleItemSkeletonDesktop expanded itemsCount={1} />
      <SingleGameSkeleton />
    </div>
  );
};
